<div #dropDownContainer class="additional-charges-div" [ngStyle]="{ 'min-width': minWidth + 'px', 'max-width': maxWidth + 'px' }">
  <label
    [ngClass]="!hideSearchBox ? 'activeSearchBox' : ''"
    class="additional-charges-form ag-size-{{ size }}"
    [ngClass]="!disable ? 'additional-charges-clickable' : 'additional-charges-disabled'"
    [attr.disabled]="disable ? '' : null"
    [ngStyle]="{ border: error ? '1px solid #E55E5E' : '', 'max-height': maxHeightNotClicked === 0 ? '' : maxHeightNotClicked + 'px', height: specificHeight === 0 ? '' : specificHeight + 'px' }"
    (click)="onFieldClicked()">
    <div class="title-container" *ngIf="size === 'large' && !multipleOutput && type !== 'country-code'">
      <span *ngIf="dropDownTitle" class="dropDownTitle" [ngStyle]="{ 'line-height': currentValue?.label.length > 0 || currentValueMultiple ? '16px' : '24px', 'font-size': currentValue?.label.length > 0 || currentValueMultiple ? '12px' : '14px' }">{{ dropDownTitle }}</span>
      <div style="overflow: hidden; text-overflow: ellipsis; width: 95%" *ngIf="multipleOutput === false && hasIcons && staticIcon === ''"><img src="{{ currentValue.value }}" /></div>
      <div style="overflow: hidden; text-overflow: ellipsis; width: 95%" *ngIf="multipleOutput === false && !hasIcons && currentValue && staticIcon === ''">{{ currentValue.label }}</div>
      <div *ngIf="(!currentValue || !currentValueMultiple) && !staticIcon">{{ hint }}</div>
    </div>

    <div class="title-container" *ngIf="type === 'country-code'">
      <span class="dropDownTitle" style="font-size: 12px; line-height: 16px; color: #5c5c5c">Country code</span>
      <div style="overflow: hidden; text-overflow: ellipsis; width: 95%" *ngIf="multipleOutput === false && !hasIcons && currentValue && staticIcon === ''">{{ currentValue.label }}</div>
      <div *ngIf="(!currentValue || !currentValueMultiple) && !staticIcon">{{ hint }}</div>
    </div>

    <div class="title-container" *ngIf="size === 'small' && !multipleOutput && type !== 'country-code'">
      <div class="flex-row flex-align-center" *ngIf="checkIfIconText()">
        <div style="overflow: hidden; text-overflow: ellipsis; width: 20%"><img src="{{ currentValue.value }}" /></div>
        <div style="overflow: hidden; text-overflow: ellipsis; width: 75%">{{ currentValue.label }}</div>
      </div>
      <ng-container *ngIf="checkIfSingleValue()">
        <div style="overflow: hidden; text-overflow: ellipsis; width: 95%" *ngIf="hasIcons"><img src="{{ currentValue.value }}" /></div>
        <div style="overflow: hidden; text-overflow: ellipsis; width: 95%" *ngIf="!hasIcons">{{ currentValue.label }}</div>
      </ng-container>
      <div *ngIf="showHint()">{{ hint }}</div>
      <div *ngIf="multipleOutput === false && staticIcon !== ''"><img src="{{ staticIcon }}" /></div>
    </div>
    <div style="overflow: hidden; text-overflow: ellipsis; width: 95%" *ngIf="multipleOutput">
      <div style="list-style: none; display: flex; flex-wrap: nowrap">
        <ng-container *ngFor="let item of currentValueMultiple; let i = index">
          <ng-container *ngIf="i > 0">, &nbsp;</ng-container>
          <li style="flex-basis: 20%">{{ item.label }}</li>
        </ng-container>
      </div>
    </div>
    <img width="16px" height="16px" [src]="hideSearchBox ? iconService.Icon.down_1 : iconService.Icon.up_1" class="disable-selection" [ngClass]="!disable ? 'additional-charges-clickable' : 'additional-charges-disabled'" />
  </label>
  <div #searchBoxWrapper class="search-box-wrapper" [ngStyle]="{ bottom: dropDownDirection === 'down' ? '' : sizeOffset }">
    <div *ngIf="type === 'text-single'">
      <ag-single-box
        [currentValue]="currentValue"
        [showSearchField]="showSearchField"
        [maxHeight]="maxHeight"
        [showBox]="!hideSearchBox"
        [showHeaders]="false"
        [hasIcons]="hasIcons"
        [list]="list"
        [disabledInputs]="disabledInputs"
        [checkboxType]="checkboxType"
        [useFixedPosition]="useFixedPosition"
        [withHoverEffect]="withHoverEffect"
        (output)="onOutput($event)"
        (searchBoxFieldClicked)="onSearchBoxFieldClicked($event)"></ag-single-box>
    </div>
    <ng-container *ngIf="type === 'text-multiple'">
      <ag-multiple-box
        [currentValueMultiple]="currentValueMultiple"
        [showSearchField]="showSearchField"
        [maxHeight]="maxHeight"
        [showBox]="!hideSearchBox"
        [showHeaders]="false"
        [showSelectAll]="showSelectAll"
        [list]="list"
        [disabledInputs]="disabledInputs"
        [checkboxType]="checkboxType"
        [useFixedPosition]="useFixedPosition"
        [withHoverEffect]="withHoverEffect"
        (outputMultiple)="onOutputMultiple($event)"
        (searchBoxFieldClicked)="onSearchBoxFieldClicked($event)"></ag-multiple-box>
    </ng-container>
    <ng-container *ngIf="type === 'country-code'">
      <ag-country-code-box
        [currentValue]="currentValue"
        [showSearchField]="showSearchField"
        [maxHeight]="maxHeight"
        [showBox]="!hideSearchBox"
        [showHeaders]="false"
        [useFixedPosition]="useFixedPosition"
        [disabledInputs]="disabledInputs"
        (output)="onOutput($event)"
        (searchBoxFieldClicked)="onSearchBoxFieldClicked($event)"></ag-country-code-box>
    </ng-container>
    <ng-container *ngIf="type === 'right-checkMark'">
      <ag-right-checkMark-box
        [currentValueMultiple]="currentValueMultiple"
        [showSearchField]="showSearchField"
        [maxHeight]="maxHeight"
        [showBox]="!hideSearchBox"
        [showSelectAll]="showSelectAll"
        [showHeaders]="false"
        [list]="list"
        [disabledInputs]="disabledInputs"
        [chooseMultiple]="chooseMultipleCheckmark"
        [useFixedPosition]="useFixedPosition"
        [withHoverEffect]="withHoverEffect"
        (outputMultiple)="onOutputMultiple($event)"
        (outputSingle)="onOutput($event)"
        (searchBoxFieldClicked)="onSearchBoxFieldClicked($event)"></ag-right-checkMark-box>
    </ng-container>
    <ng-container *ngIf="type === 'text-multiple-section'">
      <ag-multiple-section-box
        [currentValue]="currentValue"
        [currentValueMultiple]="currentValueMultiple"
        [maxWidth]="dropDownWidth"
        [disabledInputs]="disabledInputs"
        [hintForDisabledInputs]="hintForDisabledInputs"
        [maxHeight]="maxHeight"
        [showBox]="!hideSearchBox"
        [list]="list"
        [useFixedPosition]="useFixedPosition"
        [numberInSection]="numberInSection"
        [withHoverEffect]="withHoverEffect"
        (output)="unSectionOutput($event)"></ag-multiple-section-box>
    </ng-container>
    <ng-container *ngIf="type === 'icon-text'">
      <ag-icon-text-box
        [currentValue]="currentValue"
        [showSearchField]="showSearchField"
        [maxHeight]="maxHeight"
        [showBox]="!hideSearchBox"
        [showHeaders]="false"
        [hasIcons]="hasIcons"
        [list]="list"
        [disabledInputs]="disabledInputs"
        [checkboxType]="checkboxType"
        [useFixedPosition]="useFixedPosition"
        [withHoverEffect]="withHoverEffect"
        (output)="onOutput($event)"
        (searchBoxFieldClicked)="onSearchBoxFieldClicked($event)"></ag-icon-text-box>
    </ng-container>
    <ng-container *ngIf="type === 'text-single-sublabel'">
      <ag-single-sublabel-box
        [currentValue]="currentValue"
        [showSearchField]="showSearchField"
        [maxHeight]="maxHeight"
        [showBox]="!hideSearchBox"
        [list]="list"
        [disabledInputs]="disabledInputs"
        [useFixedPosition]="useFixedPosition"
        [withHoverEffect]="withHoverEffect"
        [subLabelColor]="subLabelColor"
        [subLabelSecondaryColor]="subLabelSecondaryColor"
        (output)="onOutput($event)"
        (searchBoxFieldClicked)="onSearchBoxFieldClicked($event)"></ag-single-sublabel-box>
    </ng-container>
    <ng-container *ngIf="type === 'text-single-description'">
      <ag-single-description-box
        [currentValue]="currentValue"
        [showSearchField]="showSearchField"
        [maxHeight]="maxHeight"
        [showBox]="!hideSearchBox"
        [list]="list"
        [disabledInputs]="disabledInputs"
        [useFixedPosition]="useFixedPosition"
        [withHoverEffect]="withHoverEffect"
        (output)="onOutput($event)"
        (searchBoxFieldClicked)="onSearchBoxFieldClicked($event)"></ag-single-description-box>
    </ng-container>
    <ng-container *ngIf="type === 'checkbox'">
      <ag-checkbox-box
        [currentValueMultiple]="currentValueMultiple"
        [showSearchField]="showSearchField"
        [maxHeight]="maxHeight"
        [showBox]="!hideSearchBox"
        [showHeaders]="false"
        [showSelectAll]="showSelectAll"
        [list]="list"
        [disabledInputs]="disabledInputs"
        [checkboxType]="checkboxType"
        [useFixedPosition]="useFixedPosition"
        [withHoverEffect]="withHoverEffect"
        (outputMultiple)="onOutputMultiple($event)"
        (searchBoxFieldClicked)="onSearchBoxFieldClicked($event)"></ag-checkbox-box>
    </ng-container>
    <!-- <app-search-box-v3
      [currentValue]="currentValue" [currentValueMultiple]="currentValueMultiple" [showSearchField]="showSearchField" [maxHeight]="maxHeight"
      [showBox]="!hideSearchBox" [showHeaders]="false" [alphabeticalList]="list" [noIconText]="noIconText" [hasIcons]="hasIcons"
      [useFixedPosition]="useFixedPosition"  [multipleOutput]="multipleOutput" [hint]="hint"
      (output)="onOutput($event)" (outputMultiple)="onOutputMultiple($event)" (searchBoxFieldClicked)="onSearchBoxFieldClicked($event)">
    </app-search-box-v3> -->
  </div>
  <div class="drop-down-message" *ngIf="(infoMessage && !errorMessage) || (infoMessage && errorMessage === '')">
    <img class="message-icon" src="https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Info/1.5/i_letter.svg" />
    {{ infoMessage }}
  </div>
  <div class="drop-down-message" style="color: #e55e5e" *ngIf="(!infoMessage && errorMessage) || (infoMessage === '' && errorMessage)">
    <img class="error-icon" src="https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Info/1.5/cross.svg" />
    {{ errorMessage }}
  </div>
</div>
